import Callback from "../components/Security/callback";
import Home from "../components/HomePage/tile-grid.vue";

import RFAImportSection from "../components/RFAImport/rfa-import-section";
import NewRFABatch from "../components/RFAImport/new-rfa-batch";
import AllBatches from "../components/RFAImport/rfa-batches";
import CurrentBatch from "../components/RFAImport/current-batch";



import EvaluationSection from "../components/SectionPages/evaluations";
import Billing from "../components/EvalBilling/billing-file-upload";
import Extensions from "../components/EvalExtensions/extensions-upload";

import PageNotFound from "../components/Shared/page-not-found";

export const routes = [
  {
    name: "Home",
    path: "/",
    icon: "home",
    title: "Home",
    component: Home,
    onNavBar: true,
    meta: {
      requiresAuth: false
    }
  },
  {
    name: "Evaluation",
    path: "/evaluation",
    icon: "file-invoice-dollar",
    title: "Evaluations",
    component: EvaluationSection,
    onNavBar: true,
    onTileGrid: true,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "Billing",
        path: "/evaluation/billing",
        icon: "file-invoice-dollar",
        title: "Billing",
        component: Billing,
        onNavBar: true,
        onTileGrid: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: "Extensions",
        path: "/evaluation/extensions",
        icon: "calendar-day",
        title: "Extensions",
        component: Extensions,
        onNavBar: true,
        onTileGrid: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: "RFAImport",
    path: "/rfa",
    icon: "list",
    title: "RFA Import",
    component: RFAImportSection,
    onNavBar: true,
    onTileGrid: true,
    meta: {
      requiresAuth: true
    },
    children: [
      //{
      //  name: "NewRFABatch",
      //  path: "/rfa/new",
      //  icon: "file-invoice-dollar",
      //  title: "New Import",
      //  component: NewRFABatch,
      //  onNavBar: true,
      //  meta: {
      //    requiresAuth: false
      //  }
      //},
      {
        name: "AllRFABatches",
        path: "/rfa/batches",
        icon: "list",
        title: "All Imports",
        component: AllBatches,
        onNavBar: true,
        onTileGrid: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: "CurrentBatch",
        path: "/rfa/current-batch:batchId",
        icon: "file-invoice-dollar",
        title: "Current Batch",
        component: CurrentBatch,
        onNavBar: false,
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: "Callback",
    path: "/callback",
    title: "Callback",
    component: Callback,
    onNavBar: false
  },
  {
    name: "PageNotFound",
    path: "*",
    title: "Page Not Found",
    component: PageNotFound,
    onNavBar: false,
  },
];
